// @flow

import React from "react"
import Layout from "../components/layout"
import Preview, { type BlogPreview } from "../components/BlogPreview"
import { Link, graphql } from "gatsby"
import { Helmet } from "react-helmet"

const Tags = ({ pageContext, data }: { pageContext: Object, data: Object }) => {
    const { tag } = pageContext
    const { description } = data.site.siteMetadata
    const { edges, totalCount } = data.allMarkdownRemark

    const tagHeader = `${totalCount} post${
        totalCount === 1 ? "" : "s"
    } tagged with "${tag}"`

    return (
        <Layout title={tagHeader} description={description}>
            <Helmet
                meta={[
                    {
                        name: `robots`,
                        content: `noindex, follow`,
                    },
                ]}
            />
            <h2 style={{ marginTop: 25, marginBottom: 50 }}>{tagHeader}</h2>
            <ol style={{ listStyle: `none` }}>
                {edges.map(({ node: blogPreview }: { node: BlogPreview }) => (
                    <Preview {...blogPreview} key={blogPreview.fields.slug} />
                ))}
            </ol>
            <Link to="/tags">All tags</Link>
        </Layout>
    )
}

export default Tags

export const pageQuery = graphql`
    query($tag: String) {
        site {
            siteMetadata {
                description
            }
        }
        allMarkdownRemark(
            limit: 2000
            sort: { fields: [frontmatter___date], order: DESC }
            filter: { frontmatter: { tags: { in: [$tag] } } }
        ) {
            totalCount
            edges {
                node {
                    excerpt
                    fields {
                        slug
                    }
                    frontmatter {
                        date(formatString: "MMMM DD, YYYY")
                        title
                        description
                        image
                        author
                        tags
                    }
                }
            }
        }
    }
`
